import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { MyPortfolioCapsulesWidgetState } from './MyPortfolioCapsulesWidgetsState';
import {
    buildMyPortfolioCapsulesConfigSlice,
    MyPortfolioCapsulesConfigPayloadType,
} from './config/configSlice';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const { reducer: configReducer } = buildMyPortfolioCapsulesConfigSlice();

const widgetStateReducer = combineReducers<MyPortfolioCapsulesWidgetState>({
    config: configReducer,
});

export const myPortfolioCapsulesWidgetsReducer = createWidgetsReducer<
    MyPortfolioCapsulesWidgetState,
    MyPortfolioCapsulesConfigPayloadType
>(WidgetType.MY_PORTFOLIO_CAPSULES, widgetStateReducer);
